import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setFeedModalType, toggleAddFieldModal, toggleSelectPathModal } from '../../../slices/modals/reducer';
import { loadSource } from '../../../slices/feeds/thunk';
import { createSelector } from 'reselect';
import checkPermission from '../../../Components/Hooks/PermissionHook';

function AddFieldBtn() {
  const dispatch = useDispatch();

  const selectFeedInfo = createSelector(state => state.Feed, state => state.feedInfo);
  const feedInfo = useSelector(selectFeedInfo);

  async function addField() {
    dispatch(setFeedModalType("field"));
    await dispatch(loadSource(feedInfo.source));
    // dispatch(toggleSelectPathModal());
    dispatch(toggleAddFieldModal());
  }

  const selectBrandPath = createSelector(state => state.MenuData, state => state.brandPath);
  const brandPath = useSelector(selectBrandPath);

  if (checkPermission("brands", brandPath, "feedEdit")) {
    return (
      <button type='button' className='btn btn-success ms-auto me-0 my-auto py-0'
        style={{ height: "38px" }} onClick={addField}>
        Add Field
      </button>
    )
  } else {
    return null;
  }

}

export default AddFieldBtn
